import {
  CarPortfolioAssetColumnId,
  CarPortfolioAssetTableData,
} from "../usePortfolioGroupVersionData";
import { AssetClassLevel } from "@app/const";
import { AssetAllocationModulePdfPieChart } from "./AssetAllocationModulePdfPieChart";
import { CarPdfTypography } from "@app/components/PdfTypography";
import { CarPdfBox, CarPdfBoxProps } from "@app/components/PdfBox";
import { splitArrayIntoChunks } from "@app/utils";

interface AssetAllocationSummaryPdfChartProps {
  style?: CarPdfBoxProps["style"];
  columnId: CarPortfolioAssetColumnId;
  level: AssetClassLevel;
  tableData: CarPortfolioAssetTableData;
}

export const AssetAllocationSummaryPdfChart = ({
  style,
  columnId,
  level,
  tableData,
}: AssetAllocationSummaryPdfChartProps) => {
  const rows = tableData.assetRows[level];

  const chunks = Array.from(splitArrayIntoChunks(tableData.bands, 3));

  return (
    <CarPdfBox
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        ...style,
      }}
    >
      {chunks.map((chunk, chIdx) => (
        <CarPdfBox
          key={chIdx}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            justifyContent: "center",
            gap: 8,
          }}
        >
          {chunk.map((band) => (
            <CarPdfBox
              key={band.moduleId}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 6,
                width: 160,
                maxWidth: 160,
                minWidth: 160,
              }}
            >
              <CarPdfTypography
                variant="v11Regular"
                style={{ textAlign: "center" }}
              >
                {band.label}
              </CarPdfTypography>
              <AssetAllocationModulePdfPieChart
                size={96}
                moduleId={band.moduleId}
                rows={rows}
                dataId={
                  band.columns.find((c) => c.columnId === columnId)?.dataId
                }
              />
            </CarPdfBox>
          ))}
        </CarPdfBox>
      ))}
    </CarPdfBox>
  );
};
